export * from './design-revision-judgement-edit.component';
